import { z } from 'zod';
/**
 * What kind of attention a brief item demands. Drives the per-item
 * treatment in the briefing UI (decision-hero vs watching-grid vs
 * the-call-card vs fyi-row).
 */
export const BriefItemKind = z.enum([
    'DECISION', // One action requiring CEO sign-off today
    'WATCH', // No action yet, monitor — usually 2 of these
    'CALL', // A person to reach out to today
    'SIGNAL', // External signal (industry/competitive)
    'FYI', // Lower-priority items in the long tail
]);
